import { FC, useContext } from "react";

import { FooterContext } from "src/context/footerContext";

import { LogoBrand } from "../../assets"
import { FooterTextProps } from "./types";



const FooterText: FC<FooterTextProps> = ({ footerType }): JSX.Element => {
  const { changeAccordianVisibility } =  useContext(FooterContext)

  return (
      <div className="pt-3">
        <div className="row">
          <div className="col-md-4 col-lg-3">
            <p className="fw-bold">
              Please see{' '}
              <a
                  type="button"
                  className="btn-link"
                  onClick={changeAccordianVisibility}
              >
                Important Safety Information
              </a>
              <br/>
              <span className="line-break-mobile">and{' '}
                <a
                    className="btn btn-link link-offset-0 link-offset-0-hover link-underline-primary link-underline-opacity-0 link-underline-opacity-100-hover p-0 align-baseline fw-bold"
                    href="http://www.ferringusa.com/pi/euflexxa"
                    target="_blank" rel="noreferrer"
                >
                  Full Prescribing Information
                </a>.
              </span>
            </p>
          </div>
          <div className="col-md-4 col-lg-2 pb-3 pb-sm-0">
            <img width="140px" alt="EUFLEXXA" src={LogoBrand}/>
          </div>
          <div className="col-md-4 col-lg-7">
            <p style={{textAlign:"justify"}}>
              This site is intended for US health care professionals.
              <b>REFERENCES:</b>
              1. Data on file. Ferring Pharmaceuticals Inc. (November 2023).
              2. Rolling 12 month average of IQVIA claims data based on unique patients (December 2023).
              3. MMIT medical benefit data (September 2024)l preferred status for commercial, Medicare Advantage,
              and managed Medicaid plans. Subject to change based on individual plan coverage.
              This site is intended for US health care professionals.
              © 2024 Ferring. EUFLEXXA, Ferring and the Ferring
              Pharmaceuticals logo are trademarks of Ferring. All
              other trademarks are the property of their respective
              owner(s). US-EU-2000050 v2 (9/24).
            </p>
          </div>
        </div>
      </div>
  );
};

export default FooterText;
